/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Front_Tense_Trout_PrideInputs */

const fr_front_tense_trout_pride = /** @type {(inputs: Front_Tense_Trout_PrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine précédente`)
};

/**

* @param {Front_Tense_Trout_PrideInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const front_tense_trout_pride = /** @type {((inputs?: Front_Tense_Trout_PrideInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Front_Tense_Trout_PrideInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_front_tense_trout_pride(inputs)
});